<template>
  <el-form-item prop="variableArr" ref="formItem" verify :rules="variableArrRules" class="sky-server-config">
    <div class="el-icon-question wsp-padding-lr-6 wsp-line-height-24" style="color:#38A4F5">
      用于利旧PC评估或者云桌面配置参考
    </div>
    <div :class="['sky-server-config__item', 'sk-font--B']" v-for="(item, index) in itemArr" :key="index">
      <div class="arr-item">
        <div class="arr-item-title ">终端类型：</div>
        <div class="arr-item-value  must-input">
          <el-select
            placeholder="请选择终端类型"
            v-model="item.terminalType"
            popper-class="sky-server-config__autocomplete"
            :class="`sky-server-config__select ${hasError && !item.osTypeId ? 'input-error' : ''}`"
            filterable
          >
            <el-option v-for="(item, index) in terminalTypeList" :key="index" :label="$t(item.label)" :value="item.id">
            </el-option>
          </el-select>
          <i v-if="index != 0" class="sk-icon-remove sk-font--B" @click="handleDelete(index)"></i>
        </div>
      </div>
      <div class="arr-item">
        <div class="arr-item-title ">终端型号：</div>
        <div class="arr-item-value  must-input">
          <el-input
            placeholder="请输入终端型号"
            :class="`sky-server-config__select ${hasError && !item.model ? 'input-error' : ''}`"
            v-model="item.model"
            clearable
          ></el-input>
          <i class="el-icon-arrow-right" />
          <el-input
            placeholder="请输入终端厂商"
            class="sky-server-config__select"
            v-model="item.manufacturer"
            clearable
          ></el-input>

          <div class="font-size-10 font-weight-300">终端型号： TravelMate P414-51</div>
        </div>
      </div>
      <div class="arr-item">
        <div class="arr-item-title">操作系统：</div>
        <div class="arr-item-value must-input">
          <el-select
            placeholder="请选择操作系统"
            v-model="item.osTypeId"
            popper-class="sky-server-config__autocomplete"
            :class="`sky-server-config__select ${hasError && !item.osTypeId ? 'input-error' : ''}`"
            filterable
          >
            <el-option v-for="(item, index) in osList" :key="index" :label="$t(item.label)" :value="item.id">
            </el-option>
          </el-select>
          <el-select
            placeholder="请选择是否支持UEFI"
            v-model="item.supportsUEFI"
            popper-class="sky-server-config__autocomplete"
            class="sky-server-config__select"
            filterable
            v-show="false"
          >
            <el-option v-for="(item, index) in supportUefiList" :key="index" :label="$t(item.label)" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="arr-item">
        <div class="arr-item-title ">CPU：</div>
        <div class="arr-item-value  must-input">
          <el-input
            placeholder="请输入CPU信息"
            :class="`sky-server-config__select ${hasError && !item.cpu ? 'input-error' : ''}`"
            v-model="item.cpu"
            clearable
          ></el-input>
          <i class="el-icon-arrow-right" />
          <el-input
            type="number"
            min="0"
            placeholder="请输入主频,单位:GHz"
            :class="`sky-server-config__select ${hasError && !item.cpuFrequency ? 'input-error' : ''}`"
            v-model="item.cpuFrequency"
            clearable
          ></el-input>
          <span>GHz</span>
          <i class="el-icon-arrow-right" />
          <el-input
            type="number"
            min="0"
            oninput="value=value.replace(/[^0-9]/g,1)"
            placeholder="请输入CPU核数大小"
            class="sky-server-config__select"
            v-model="item.cpuCore"
            clearable
          ></el-input>
          <div class="font-size-10 font-weight-300">CPU： 11th Gen Intel(R) Core(TM) i5-1135G7 @ 2.40GHz</div>
        </div>
      </div>
      <div class="arr-item">
        <div class="arr-item-title ">内存：</div>
        <div class="arr-item-value">
          <el-input
            type="number"
            :min="0"
            oninput="value=value.replace(/[^0-9]/g,1)"
            placeholder="请输入总内存大小(G)"
            :class="`sky-server-config__select`"
            v-model="item.memory"
          ></el-input>
        </div>
      </div>
      <div class="arr-item">
        <div class="arr-item-title ">硬盘：</div>
        <div class="arr-item-value">
          <el-input
            type="number"
            min="0"
            oninput="value=value.replace(/[^0-9]/g,1)"
            placeholder="请输入硬盘大小"
            :class="`sky-server-config__select`"
            v-model="item.diskSize"
          ></el-input>
          <i class="el-icon-arrow-right" />
          <el-input
            type="number"
            min="0"
            oninput="value=value.replace(/[^0-9]/g,1)"
            placeholder="请输入硬盘数量"
            class="sky-server-config__select"
            v-model="item.diskCount"
            clearable
          ></el-input>
        </div>
      </div>
      <div class="arr-item">
        <div class="arr-item-title ">显卡：</div>
        <div class="arr-item-value">
          <el-input
            placeholder="请输入显卡信息"
            class="sky-server-config__select"
            v-model="item.gpuModel"
            clearable
          ></el-input>
          <div class="font-size-10 font-weight-300 bg-red">3D设计场景必须收集显卡型号</div>
        </div>
      </div>
      <div v-if="index + 1 != itemArr.length" class="arr-item" style="border: 1px solid;width:40%"></div>
      <!-- <div class="font-size-8">请填写系统信息</div> -->
      <!-- <div>
        
        
      </div> -->
      <!-- <div class="font-size-8">请填写CPU信息</div> -->
      <div></div>
      <!-- <div class="font-size-8">请填写内存信息</div> -->
      <div></div>
      <!-- <div class="font-size-8">请填写硬盘数量</div> -->
      <div></div>
      <!-- <div class="font-size-8">请输入显卡信息</div> -->
    </div>
    <el-button
      v-show="showAddButton()"
      type="text"
      class="el-icon-plus sky-branch-pattern__add"
      style="margin-top:5px"
      @click="handleAdd"
    >
      添加
    </el-button>
  </el-form-item>
</template>
<script type="text/babel">
import { Select, Option, Input, Button } from 'element-ui'
import { action } from 'sky-engine/api'

import { OSTYPE_MNG } from '@/api/apiModules'

export default {
  name: 'SkyReportTerminalRelate',
  inject: ['rootView', 'elForm'],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    value: {
      type: [String, Array, Object],
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      itemArr: [
        {
          supportsUEFI: true,
          cpuCore: null,
          cpu: null,
          diskCount: null,
          diskSize: null,
          memory: null,
          gpuModel: null,
          cpuFrequency: null,
          model: '默认终端型号'
        }
      ],
      loading: false,
      hasError: false,
      osList: [],
      supportUefiList: [
        {
          id: false,
          label: '否'
        },
        {
          id: true,
          label: '是'
        }
      ],
      terminalTypeList: [
        {
          id: 'PC',
          label: '客户现网PC'
        },
        {
          id: 'CLOUD',
          label: '客户现网云桌面'
        }
      ],
      isCb: false
    }
  },
  mounted() {
    action(OSTYPE_MNG, 'findAllActive').then(response => {
      this.osList = response.data.content.itemArr.map(item => {
        return {
          id: item.id,
          label: item.osType
        }
      })
    })
  },
  computed: {
    variableArrRules() {
      const validatorBranch = (rule, value, callback) => {
        this.hasError = false
        for (const item of this.itemArr) {
          if (!this.isFill(item)) {
            this.hasError = true
            callback(new Error(this.$t('请输入未填项')))
          }
        }
        if (!this.hasError) {
          callback()
        }
      }
      return [[{ validator: validatorBranch, trigger: ['blur', 'change'] }]]
    }
  },
  watch: {
    value(value) {
      if (this.value?.terminalType && !this.isCb) {
        this.handleFill(value)
      }
    },
    itemArr: {
      handler: function(value) {
        this.$emit('input', value)
      },
      deep: true
    }
  },
  methods: {
    isFill(item) {
      return item.terminalType && item.osTypeId && item.model && item.cpu && item.cpuFrequency
    },
    handleFill(value) {
      this.isCb = true
      this.itemArr[0] = value
      this.$emit('input', this.itemArr)
    },
    handleAdd() {
      this.itemArr.push({
        supportsUEFI: true,
        cpuCore: null,
        cpuFrequency: null,
        cpu: null,
        diskCount: null,
        diskSize: null,
        memory: null,
        gpuModel: null,
        model: '默认终端型号'
      })
    },
    showAddButton() {
      if (this.itemArr?.length >= 5) {
        return false
      }
      return !this.isEdit
    },
    handleDelete(index) {
      this.itemArr.splice(index, 1)
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(version-variable) {
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
}

.el-form-item.is-error .sky-server-config__item .el-input__inner {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
@include b(server-config) {
  margin-bottom: 0px !important;
  @include e(autocomplete) {
    width: auto !important;
    min-width: 180px;
  }
  @include e(select) {
    width: 180px !important;
  }
  @include e(select) {
    width: 180px !important;
  }
  @include e(mutiple-select) {
    width: 300px !important;
  }

  @include e(item) {
    line-height: 30px;
    word-break: break-all;
    width: 1400px !important;

    // color: $--color-text-regular;
    & .active {
      // color: $--color-text-regular;
    }
    .arr-item {
      display: flex;
      .arr-item-title {
        padding: 0 12px;
        width: 10%;
        line-height: 32px;
      }
      .input-error {
        .el-input__inner {
          border-bottom: 1px solid #df1b1b !important;
        }
      }
    }

    .must-input:before {
      content: '*';
      color: #df1b1b;
      margin-right: 0.16667rem;
    }
  }
  & i {
    margin-right: 5px;
    color: gray;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
